import * as React from 'react'
import {useContext} from 'react'

import {useAppDispatch} from '../../../../../hooks/react-redux'
import PopupMenu from '../../../../common/Popup/PopupMenu'
import {changeLogFilterAndFetchMessages} from '../FullBuildLog.actions'
import {TargetContext} from '../FullBuildLog.context'

type Props = {}
export const filterLabels = {
  err: 'Errors',
  important: 'Important messages',
  all: 'All Messages',
  debug: 'Verbose',
}

function BuildLogFilterMenu({...restProps}: Props) {
  const target = useContext(TargetContext)
  const dispatch = useAppDispatch()

  const filterItems = [
    {
      label: filterLabels.err,
      onClick: React.useCallback(() => {
        dispatch(changeLogFilterAndFetchMessages(target, 'err'))
      }, [dispatch, target]),
    },
    {
      label: filterLabels.important,
      onClick: React.useCallback(() => {
        dispatch(changeLogFilterAndFetchMessages(target, 'important'))
      }, [dispatch, target]),
    },
    {
      label: filterLabels.all,
      onClick: React.useCallback(() => {
        dispatch(changeLogFilterAndFetchMessages(target, null))
      }, [dispatch, target]),
    },
    {
      label: filterLabels.debug,
      onClick: React.useCallback(() => {
        dispatch(changeLogFilterAndFetchMessages(target, 'debug'))
      }, [dispatch, target]),
    },
  ]
  return <PopupMenu {...restProps} closeOnSelect data={filterItems} />
}

export default React.memo(BuildLogFilterMenu)
